import React from "react";
import { Link } from "react-router-dom";
import { FaGraduationCap, FaPassport } from "react-icons/fa6";
import { AiOutlineComment } from "react-icons/ai";
import { WebPaths } from "../../../../routes/data";
import Button from "../../components/ui/Button";
import { landingHeroImage } from "../../../../images";

const HeroReskinned: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      {/* Headline + subhead */}
      <div className="mx-auto w-full max-w-5xl px-6 pt-16 text-center sm:pt-20 md:pt-24">
        <h1 className="mx-auto max-w-4xl text-h1 font-light tracking-tight text-black">
          <span className="">
            Your Ambition Knows <br /> No
          </span>
          <span className="mt-3 inline-flex rounded-2xl align-middle">
            <div className="bg-blue-200 rounded-3xl p-2 -rotate-1 md:-rotate-2 ">
              <span className="relative inline-flex items-center gap-2 rounded-2xl bg-blue-00 px-4 py-2 text-white">
                <span className="italic">Borders</span>
              </span>
            </div>
          </span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-balance text-gray-600">
          Your trusted platform for study abroad, immigration, and global travel
          visas — powered by intelligent technology and expert guidance.
          SeamlessVisa helps individuals, families, and businesses navigate
          complex immigration and visa processes across top destinations
          including <span className="font-semibold text-black-31">Canada </span>
          , the{" "}
          <span className="font-semibold text-black-31">United States</span>,
          the{" "}
          <span className="font-semibold text-black-31">United Kingdom</span>,{" "}
          <span className="font-semibold text-black-31">Europe</span>, and{" "}
          <span className="font-semibold text-black-31">beyond </span>. Whether
          you're pursuing education, relocating for work, joining family, or
          exploring the world — we simplify every step.
        </p>

        {/* CTAs */}
        <div className="mx-auto mt-8 flex w-full max-w-2xl flex-wrap items-center justify-center gap-3">
          <Link to={WebPaths.Academy}>
            <Button
              label="Study Abroad"
              onClick={() => {}}
              startIcon={<FaGraduationCap className="h-5 w-5" />}
              variant="primary"
              iconHoverStyle="scale"
            />
          </Link>

          <Link to={WebPaths.VisaServices}>
            <Button
              label="Visa Services"
              onClick={() => {}}
              startIcon={<FaPassport className="h-5 w-5" />}
              variant="secondary"
              iconHoverStyle="scale"
            />
          </Link>

          <Link to={WebPaths.FiBiAi}>
            <Button
              label="Try FiBi AI interview"
              onClick={() => {}}
              startIcon={<AiOutlineComment className="h-5 w-5" />}
              variant="fibi"
              iconHoverStyle="scale"
            />
          </Link>
        </div>
      </div>

      {/* Bottom screenshot */}
      <div className="mx-auto mt-12 w-full max-w-6xl px-6 pb-12">
        <div className="relative overflow-hidden rounded-3xl border border-gray-200 p-2 shadow-3xl bg-blue-100">
          <img
            src={landingHeroImage}
            alt="Product preview"
            className="h-auto w-full rounded-xl"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroReskinned;
